<template>
  <div>
    <v-toolbar
      color="blue-grey"
      dark
      tabs
    >
      <v-toolbar-title>อาคาร/ห้องเรียน</v-toolbar-title>

      <v-tabs
        slot="extension"
        v-model="model"
        centered
        color="blue-grey"
        slider-color="yellow"
      >
        <v-tab
          v-for="i in tabItems"
          :key="i.key"
          :href="`#${i.key}`"
        >
          {{ i.text }}
        </v-tab>
      </v-tabs>
    </v-toolbar>

    <v-tabs-items v-model="model">
      <v-tab-item
        v-for="i in tabItems"
        :value="`${i.key}`"
        :key="i.key"
      >
        <v-card flat>
          <v-card-text>
            <component :is="i.key"></component>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import BuildingDataTable from './dataTables/building.vue'
import RoomDataTable from './dataTables/room.vue'

export default {
  components: {
    BuildingDataTable,
    RoomDataTable
  },
  data () {
    return {
      currentView: null,
      model: 'building-data-table',
      tabItems: [
        { key: 'building-data-table', text: 'อาคาร' },
        { key: 'room-data-table', text: 'ห้องเรียน' }
      ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/settings/building/index.vue